export enum EBookletAttachmentName {
  APE = 'ape',
  LAND_REGISTRY = 'landRegistry',
  DEED_OF_ORIGIN = 'deedOfOrigin',
  URBAN_PLANNING = 'urbanPlanning',
  OCCUPANCY_PERMIT = 'occupancyPermit',
  SYSTEMS = 'systems',
  BOILER = 'boiler',
  CDU = 'cdu',
  LATENT_DEFECTS_INSURANCE = 'latentDefectsInsurance',
  TECHNICAL_REPORT = 'technicalReport',
  EXTRA = 'extra',
  EXTRA_CONTRACT = 'extraContract',
  SELLER_IDENTITY_CARD = 'sellerIdentityCard',
  CASA_DOC_CONTRACT = 'casaDocContract',
  APE_SURVEYOR_SURVEY = 'apeSurveyorSurvey',
  APE_SURVEYOR_PICTURES = 'apeSurveyorPictures',
  OTHERS = 'others',
  CASA_DOC_INVOICE = 'casaDocInvoice',
  SURVEYOR_INVOICE = 'surveyorInvoice',
  EXTRA_CASA_DOC_INVOICE = 'extraCasaDocInvoice',
  COST_SUMMARY = 'costSummary',
  EXTRA_COST_SUMMARY = 'extraCostSummary',
  UNIFIED_COST_SUMMARY = 'unifiedCostSummary',
}
